<template>
	<c-dialog ref="dialog" mask-close mode="slide" width="70vw">
        <c-form vertical unit-width="100%">
			<c-title>产品明细</c-title>
            <c-form-item :label="false">
                <m-operate border>
                    <c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanHandle">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
					<c-button color="main" @click="scanHandle">确定</c-button>
					<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
                </m-operate>
				<!-- 已扫码列表 -->
				<c-table ref="list" :data="scannedList" border @dataChange="selectChange">
					<template #empty>
						<c-empty message="请扫描产品背贴码"></c-empty>
					</template>

					<c-table-column type="selector" width="32"></c-table-column>
					<c-table-column label="产品信息">
						<template #default="{data}">{{getProductText(data)}}</template>
					</c-table-column>
					<c-table-column label="背贴码" width="150">
						<template #default="{data}">{{data.produce_unique_code}}</template>
					</c-table-column>
					<c-table-column label="IMEI" width="160">
						<template #default="{data}">{{data.produce_imei || '-'}}</template>
					</c-table-column>
					<c-table-column label="成本价" width="80">
						<template #default="{data}">{{formatPrice(data.cost_price)}}</template>
					</c-table-column>
					<c-table-column label="转交人" width="80">
						<template #default="{data}">{{data.handover_user_name || '-'}}</template>
					</c-table-column>
					<c-table-column label="操作" width="80" type="button">
						<template #default="{data}">
							<c-table-button icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
            </c-form-item>

			<!-- 驳回备注 -->
			<template v-if="isReject">
				<c-title>备注信息</c-title>
				<c-form-item :label="false">
					<c-input type="textarea" :height-resize="{minHeight: '120px'}" name="remark" v-model="rejectReason" placeholder="请输入驳回原因（选填）" maxlength="500"></c-input>
				</c-form-item>
			</template>
        </c-form>

		<template #button>
			<c-button size="dialog" :color="isReject ? 'red' : 'main'" :disabled="!scannedList.length" @click="batchSubmit">{{submitText}}</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
export default {
	name: 'handoverDialog',

	props: {
        initialList: {type: Array, default: () => []},
		// 模式：accept 接驳 / reject 驳回
		mode: {
			type: String,
			default: 'accept'
		},
		// 接驳类型：1 质检 / 2 维修 / 3 销售
		type: {
			type: Number,
			default: 1
		}
	},

	data() {
		return {
			scanCode: '',
			scannedList: [],
			selectedList: [],
			rejectReason: ''
		}
	},

	computed: {
		/*********是否为驳回模式**********/
		isReject() {
			return this.mode === 'reject';
		},

		/*********弹窗标题**********/
		dialogTitle() {
			var action = this.isReject ? '驳回' : '接驳';
			return this.typeName + '批量' + action;
		},

		/*********提交按钮文字**********/
		submitText() {
			return this.isReject ? '确定驳回' : '确定接驳';
		},

		/*********底部统计文字**********/
		statText() {
			return this.isReject ? '待驳回记录' : '待接驳记录';
		},

		/*********接驳类型名称**********/
		typeName() {
			var nameMap = {1: '质检', 2: '维修', 3: '销售'};
			return nameMap[this.type] || '';
		}
	},

	methods: {
		/*********格式化价格**********/
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '¥' + parseFloat(price);
		},

		/*********打开弹框**********/
		open() {
			this.scanCode = '';
			this.scannedList = this.initialList.slice();
			this.selectedList = [];
			this.rejectReason = '';
			this.$refs.dialog.open({title: this.dialogTitle});
			this.focusInput();
		},

		/*********聚焦输入框**********/
		focusInput() {
			this.$nextTick(() => {
				var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
				if (input) input.focus();
			});
		},

		/*********扫码处理**********/
		scanHandle() {
			var code = this.scanCode.trim();
			if (!code) {
				this.$message({message: '请输入背贴码', type: 'warn'});
				return;
			}
			if (this.scannedList.some(item => item.produce_unique_code == code)) {
				this.$message({message: '该背贴码已扫描', type: 'warn'});
				this.scanCode = '';
				this.focusInput();
				return;
			}
			this.request({
				url: '/handover/queryByCode',
				data: {
					produce_unique_code: code,
					handover_type: this.type
				},
				success: (data) => {
					if (data.handover_state != 1) {
						this.$message({message: '该记录已被处理，无法' + (this.isReject ? '驳回' : '接驳'), type: 'warn'});
					} else {
						this.scannedList.push(data);
					}
					this.scanCode = '';
					this.focusInput();
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'warn'});
					this.scanCode = '';
					this.focusInput();
				}
			});
		},

		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			return parts.join(' ') || '-';
		},

		/*********选中变化**********/
		selectChange() {
			this.selectedList = this.$refs.list.getData('selected');
		},

		/*********移除已扫项**********/
		removeItem(data) {
			this.scannedList = this.scannedList.filter(item => item.id != data.id);
			this.focusInput();
		},

		/*********批量移除选中项**********/
		batchRemove() {
			if (!this.selectedList.length) {
				this.$message({message: '请先勾选要移除的记录', type: 'warn'});
				return;
			}
			var ids = this.selectedList.map(item => item.id);
			this.scannedList = this.scannedList.filter(item => !ids.includes(item.id));
			this.selectedList = [];
			this.focusInput();
		},

		/*********批量提交（接驳/驳回）**********/
		batchSubmit() {
			if (!this.scannedList.length) return;
			var ids = this.scannedList.map(item => item.id);
			var action = this.isReject ? '驳回' : '接驳';
			var url = this.isReject ? '/handover/batch/reject' : '/handover/batch/accept';
			var data = {ids: ids};
			if (this.isReject) {
				data.reject_reason = this.rejectReason;
			}
			this.$confirm({
				message: '确认' + action + ids.length + '条' + this.typeName + '接驳记录吗？',
				cancelButton: true,
				resolve: () => {
					this.request({
						url: url,
						data: data,
						loading: true,
						success: (res, msg) => {
							this.$message({message: msg, type: 'success'});
							this.scannedList = [];
							if (this.isReject) {
								this.closeDialog();
							} else {
								this.focusInput();
							}
							this.$emit('resolve');
						}
					});
				}
			});
		},

		/*********关闭弹框**********/
		closeDialog() {
			this.$refs.dialog.close();
		}
	}
}
</script>

<style lang="stylus" scoped>
.detail-card
	border 1px solid #e8e8e8
	border-radius 4px
	overflow hidden
	> .c-title
		padding 10px 16px
		margin 0
		border-bottom 1px solid #e8e8e8
	.toolbar
		padding 10px 16px
		margin 0
		> * + *
			margin-left 8px
		.scan-input
			position relative
			width 220px
			.scan-icon
				position absolute
				left 8px
				top 50%
				transform translateY(-50%)
				font-size 16px
				color #999
				z-index 1
.empty-state
	padding 40px 0
	text-align center
	color #999
	.empty-icon
		font-size 48px
		color #ccc
	p
		margin-top 10px
		font-size 14px
.stat-area
	padding 10px 0
	text-align left
	color #666
	font-size 14px
	b
		color #1890ff
</style>
